document.addEventListener('DOMContentLoaded', function() {
    const headings = document.querySelectorAll('.footer-block__heading');

    headings.forEach(function(heading) {
      heading.addEventListener('click', function() {
        this.classList.toggle('active');
        const content = this.nextElementSibling;  
        content.classList.toggle('active');
      });
    });

    const menu_link_footer = document.querySelectorAll(".footer-block__details-content .submenu");

    menu_link_footer.forEach(function(link) {
      link.addEventListener('click', function() {
        this.classList.toggle('active');
        const content = this.querySelector("ul");
        if (content) {
          content.classList.toggle('active');
        }
      });
    });
  });